import { render } from "./ModeloUpdate.vue?vue&type=template&id=2b7c5a7b&scoped=true"
import script from "./ModeloUpdate.vue?vue&type=script&lang=ts"
export * from "./ModeloUpdate.vue?vue&type=script&lang=ts"

import "./ModeloUpdate.vue?vue&type=style&index=0&id=2b7c5a7b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b7c5a7b"

export default script